import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CaseDetailsApiService, DownloadAllCaseEvidenceRequest } from '@intrensic/cases-management/data-access';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';
import { NotificationService } from '@shared/feature/notification-handling';
import { TranslationFromJsonService } from '@shared/feature/translate';
import { BaseModalComponent } from '@shared/ui/modal';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'sh-shared-layout-download-all-evidence-dialog',
  templateUrl: './download-all-evidence-dialog.component.html',
  styleUrls: ['./download-all-evidence-dialog.component.css'],
  standalone: false,
})
export class DownloadAllEvidenceDialogComponent extends StaticPropsComponentExtensions implements OnInit, OnDestroy {
  @ViewChild(BaseModalComponent) baseModal?: BaseModalComponent;

  public downloadAllFormGroup = new FormGroup({
    agreement: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.pattern('^(agree|Agree|AGREE)$')] }),
    reason: new FormControl('', { nonNullable: true }),
  });
  public hasLockedEvidence = false;
  public settingsFetched = false;

  private ngUnsubscribe$ = new Subject<void>();

  constructor(
    private caseDetailsApiService: CaseDetailsApiService,
    private agencyDetailsFacade: AgencyDetailsFacade,
    private notificationService: NotificationService,
    private translationService: TranslationFromJsonService
  ) {
    super();
  }

  ngOnInit(): void {
    this.agencyDetailsFacade
      .getAgencySettings()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((settings) => {
        if (settings.useDownloadReason && settings.downloadReasonMinLength) {
          this.downloadAllFormGroup.controls.reason.setValidators([Validators.required, Validators.minLength(settings.downloadReasonMinLength), Validators.maxLength(250)]);
        } else {
          this.downloadAllFormGroup.controls.reason.setValidators([Validators.maxLength(250)]);
        }
        this.settingsFetched = true;
      });
  }

  onSendRequest(): void {
    if (this.downloadAllFormGroup.valid) {
      this.caseDetailsApiService.downloadAllCaseEvidence(new DownloadAllCaseEvidenceRequest(this.downloadAllFormGroup.controls.reason.value)).subscribe(() => {
        this.notificationService.addSuccess(this.translationService.instant('successfully-performed-operation'));
        this.baseModal?.activeModal.close();
      });
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
